<template>
    <div class=" gcmcn-card-gradient">

        <div class="import-modal-content">
            <p class="modal-label">{{ importModalLabel }}</p>
            <div
                v-if="loading"
                class="loader-container"

            >
                <loader
                ></loader>
            </div>
            <el-form
                v-else-if="!loading && !hasRelatedRequest"
                ref="form"
                :model="form"
                :rules="rules"
            >
                <el-form-item class="gcmcn-form-input" prop="file">
                    <el-upload
                        v-model="form.file"
                        class="upload-file"
                        ref="upload"
                        action=""
                        :auto-upload="false"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :file-list="fileList"
                        accept=".csv"
                    >
                        <el-button
                            slot="trigger"
                            size="small"
                            type="primary"
                        >
                            Choose a file
                        </el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div v-else-if="!loading && hasRelatedRequest">
                <div v-if="isError">
                    <el-button
                        type="info"
                        class="small copy-btn"
                        size="mini"
                        @click="copyText"
                    >
                        Copy
                    </el-button>
                </div>
                <div>
                    <div
                        v-if="requestVerbose"
                        class="error-container"
                    >{{ requestVerbose }}</div>
                    <div
                        v-if="warningRequestVerbose"
                        class="error-container"
                    >{{ warningRequestVerbose }}</div>
                </div>
            </div>
        </div>
        <div
            v-if="!loading"
            class="modal-buttons"
        >
            <el-button
                v-if="hasRelatedRequest"
                @click="leaveDetails"
                type="danger"
                class="gcmcn-danger-btn small"
            >
                Cancel
            </el-button>

            <el-button
                v-if="!hasRelatedRequest"
                type="primary"
                class="gcmcn-primary-btn small"
                :disabled="!form.file"
                @click="importFile"
            >
                Start import
            </el-button>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/loader-template.vue';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
export default {

    name: 'import-modal',

    components:{
        DefaultModal,
        Loader
    },


    props: {
        entity: {
            type: Object,
            required: true,
        },
    },

    data () {
        return {
            form:{
                file: null
            },
            rules:{
                file: [
                    { required: true, message: 'this field is required' }
                ],
            },
            loading: false,
            isError: false,
            isSuccess: false,
            requestVerbose: '',
            warningRequestVerbose: '',
            fileList: [],
        };
    },

    computed:{
        importModalLabel(){
            if(this.isSuccess){
                return 'Success';
            }
            if(this.isError){
                return 'Error';
            }
            return 'Import feeds';
        },
        hasRelatedRequest(){
            if(this.isError || this.isSuccess){
                return true;
            }
            return false;
        },
    },

    methods:{
        copyText() {
            navigator.clipboard.writeText(this.requestVerbose);
            this.$notify.success({
                title: 'Copied',
            });

        },
        leaveDetails(){
            if(this.form.file && !this.hasRelatedRequest){
                this.$refs.upload.clearFiles();
            }
            this.$set(this, 'fileList', []);
            this.$set(this.form, 'file', null);
            this.$set(this, 'requestVerbose', '');
            this.$set(this, 'warningRequestVerbose', '');
            this.$set(this, 'isError', false);
            this.$set(this, 'isSuccess', false);
        },
        importFile(){
            this.$refs.form.validate((valid) => {
                if(valid){
                    // The line below allows you to retrieve the file name without the extension
                    let fileName = this.form.file.name.replace(/\.[^/.]+$/, '');
                    this.loading = true;
                    this.$store.dispatch('createItem', {
                        item:{
                            name: fileName,
                            status: 'WAITING_FOR_UPLOAD'
                        },
                        model: 'importFeedRequest',
                        url: this.$store.state.api.meta.listModels.importFeedRequest.url,
                        scopes: {'X-Entity-Uid': this.entity.uid},
                    })
                    .then((res) => {
                        let fd = new FormData();
                        fd.append('file', this.form.file);
                        fd.append('status', 'PENDING');
                        this.$store.dispatch('patchItemFormData', {
                            item: fd,
                            url: res.url,
                            model: 'importFeedRequest',
                        }).then(async() => {
                            this.$store.dispatch('fundation/watchRequestStatus',{
                                url: res.url
                            }).then((res) => {
                                this.$notify.success({
                                    title: 'Success',
                                });
                                this.isSuccess = true;
                                this.loading = false;
                                this.$set(this.form, 'file', null);

                                this.$set(this, 'requestVerbose', res.data.verbose_status);
                                this.$set(this, 'warningRequestVerbose', res.data.warning_verbose_status);
                            }).catch((error) => {
                                this.isError = true;
                                this.loading = false;
                                this.$set(this, 'requestVerbose', error.data.verbose_status);
                            });
                        }).catch((e) => {
                            this.loading = false;
                            console.error(e);
                        });
                    }).catch((e) => {
                        this.loading = false;
                        console.error(e);
                    });
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Please select a file',
                    });
                }
            });
        },
        handleChange(file){
            this.$refs.upload.clearFiles();
            this.form.file = file.raw;
            this.$set(this, 'fileList', [file]);
        },
        handleRemove(){
            this.$refs.upload.clearFiles();
            this.form.file = null;
        },
    }
};
</script>

<style lang="scss">
.scrollable-list {
  padding: 0;
}
.upload-file{
    input{
        display: none;
    }
}
.upload-file{
    .el-upload-list{
        .el-upload-list__item:hover{
            background-color: #333333;
        }
        .el-upload-list__item{
            transition: none;
            -webkit-transition: none;
            &.el-list-leave-active{
                transition: none;
                -webkit-transition: none;
            }
        }
    }
}
.import-modal-content {
  display: flex;
  flex-direction: column;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
}
.modal-label{
    margin-bottom: 3em;
    color: #BBBBBB;
}
.copy-btn{
    margin-bottom: 2rem;
}
.error-container{
    white-space: pre;
    text-transform: none;
    color: #BBBBBB;
    margin-bottom: 1rem;
}
.loader-container{
    margin-left: auto;
    margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Entities/import-feeds-view.vue